/**
 * The planner's motion — design_handoff_auth_profile_planner §5 (Sept 27 2026), verbatim.
 * Ease-out `cubic-bezier(0,0,.2,1)` for arrivals, `cubic-bezier(.6,0,.2,1)` for draws and moves.
 * Every animation is tagged `data-motion` (and stroke draws `data-draw`) so `.pl-reduced` and the
 * OS setting can stop them all and land on the end state.
 */
const css = `
@keyframes plDraw    { to { stroke-dashoffset: 0; } }
@keyframes plFade    { from { opacity: 0; } to { opacity: 1; } }
@keyframes plDrop    { 0% { transform: translateY(-170px); opacity: 0; } 15% { opacity: 1; } 64% { transform: translateY(0) scaleY(1); } 76% { transform: scaleY(.86); } 88% { transform: scaleY(1.05); } 100% { transform: none; opacity: 1; } }
@keyframes plPop     { 0% { transform: scale(0); opacity: 0; } 65% { transform: scale(1.14); opacity: 1; } 100% { transform: scale(1); opacity: 1; } }
@keyframes plStamp   { 0% { transform: rotate(-9deg) scale(1.9); opacity: 0; } 45% { opacity: 1; } 100% { transform: rotate(-9deg) scale(1); opacity: 1; } }
@keyframes plSlide   { from { transform: translateX(-200px); opacity: 0; } to { transform: none; opacity: 1; } }
@keyframes plBall    { from { transform: translateY(-300px); } to { transform: none; } }
@keyframes plShimmer { 0%, 100% { filter: brightness(1) drop-shadow(0 0 10px rgba(34,236,251,.5)); } 50% { filter: brightness(1.3) drop-shadow(0 0 22px rgba(253,25,159,.7)); } }
@keyframes plBeam    { from { transform: rotate(-14deg); } to { transform: rotate(14deg); } }
@keyframes plSpeck   { 0%, 100% { opacity: 0; transform: scale(.4); } 30% { opacity: 1; transform: scale(1); } 60% { opacity: .25; } }
@keyframes plSweep   { from { transform: translateY(-20px); } to { transform: translateY(460px); } }
@keyframes plWave    { from { transform: scale(.7); opacity: .9; } to { transform: scale(2.1); opacity: 0; } }
@keyframes plPin     { 0% { transform: translateY(-40px); opacity: 0; } 70% { transform: translateY(4px); opacity: 1; } 100% { transform: none; opacity: 1; } }
@keyframes plPing    { from { transform: scale(.3); opacity: .9; } to { transform: scale(1.7); opacity: 0; } }
@keyframes plChip    { from { opacity: 0; transform: translateY(12px) scale(.9); filter: blur(6px); } to { opacity: 1; transform: none; filter: none; } }
@keyframes plPrint   { from { transform: scaleX(0); } to { transform: scaleX(1); } }
@keyframes plBob     { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }
@keyframes plScanOnce { from { top: -4px; opacity: 1; } to { top: 100%; opacity: 0; } }
@keyframes plTip     { from { transform: rotate(0); } to { transform: rotate(-14deg); } }

.pl-scan  { position: absolute; left: 0; right: 0; top: -4px; height: 3px; background: #22ECFB; box-shadow: 0 0 14px #22ECFB; animation: plScanOnce .55s linear forwards; pointer-events: none; }
.pl-caret { display: inline-block; width: 8px; height: 14px; background: #22ECFB; vertical-align: -2px; animation: prBlink 1s steps(1) infinite; }
.pl-chip  { animation: plChip .5s cubic-bezier(0,0,.2,1) both; }
.pl-tip   { transform-origin: 0% 100%; transform-box: fill-box; animation: plTip .5s cubic-bezier(0,0,.2,1) both; }

.pl-reduced [data-motion], .pl-reduced .pl-scan, .pl-reduced .pl-caret, .pl-reduced .pl-chip, .pl-reduced .pl-tip { animation: none !important; }
.pl-reduced [data-draw] { stroke-dashoffset: 0 !important; }
.pl-reduced .pl-scan, .pl-reduced [data-speck], .pl-reduced [data-sweep] { display: none !important; }
.pl-reduced .pl-tip { transform: rotate(-14deg); }
@media (prefers-reduced-motion: reduce) {
  [data-motion], .pl-scan, .pl-caret, .pl-chip, .pl-tip { animation: none !important; }
  [data-draw] { stroke-dashoffset: 0 !important; }
  .pl-scan, [data-speck], [data-sweep] { display: none !important; }
  .pl-tip { transform: rotate(-14deg); }
}
`;

export default function PlannerStyles() {
  return <style>{css}</style>;
}
